import { QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import ReactDOM from "react-dom/client";
import "ui/styles.css";
import App from "./App";
import { ContainersMap } from "./constants/config";
import "./index.css";
import queryClient from "./instances/react-query-client";
import { exposeApp } from "./utils/render-manager";
import { registerWebComponents } from "@elixir/utils";
import ExposableSelectSlotModal from "./organisms/select-slot-modal/exposable-select-slot-modal";
import populateBusinessUsersFuse from "./utils/populate-business-users";
import { ExposableAptActivity } from "./organisms/appointment-logs-darwer/exposable-apt-activity";
import { initBridge } from "./utils/bridges/EkaBridge";

console.log("fdsafdasfdshererehre");
initBridge();

if (import.meta.env.VITE_APP_MODE == "DEBUG") {
  setTimeout(() => {
    ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
      <React.StrictMode>
        <ApplicationWrapper>
          <App />
        </ApplicationWrapper>
      </React.StrictMode>
    );
  }, 2000);
  // exposeApp();
} else {
  exposeApp();
  window.RENDER_CONFIGS?.forEach(
    ({ containerId, routeParams, queryParams, ...params }) => {
      if (containerId === ContainersMap.BILLING_QUEUE) {
        window.billingDashboard({ containerId, routeParams, queryParams });
      }
      if (containerId === ContainersMap.RECEIPT_CUSTOMISATION) {
        window.receiptCustomisation({ containerId, routeParams, queryParams });
      }
      if (containerId === ContainersMap.NEW_APPOINTMENT_DASHBOARD) {
        window.renderNewAppt({ containerId, routeParams, queryParams });
      }
      if (containerId === ContainersMap.GLOBAL_SEARCH_APPT) {
        window.renderAppointmentWidget({
          containerId,
          routeParams,
          queryParams,
          ...params,
        });
      }
      if (containerId === ContainersMap.CURRENT_TREATMENT_CONTAINER_ID) {
        window.currentTreatmentScreen({
          containerId,
          routeParams,
          queryParams,
          ...params,
        });
      }
      if (containerId === ContainersMap.MANAGE_TREATMENTS_CONTAINER_ID) {
        window.manageTreatmentPackagesScreen({
          containerId,
          routeParams,
          queryParams,
          ...params,
        });
      }
      if (containerId === ContainersMap.MANAGE_SERVICES_CONTAINER_ID) {
        window.manageServicesScreen({
          containerId,
          routeParams,
          queryParams,
          ...params,
        });
      }
      if (containerId === ContainersMap.APPOINTMENT_CONFIGS_CONTAINER_ID) {
        window.appointmentConfigsScreen({
          containerId,
          routeParams,
          queryParams,
          ...params,
        });
      }
    }
  );
}

export function ApplicationWrapper({ children }: React.PropsWithChildren<{}>) {
  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
}

registerWebComponents({
  componentList: {
    "select-slot-modal": {
      Component: ExposableSelectSlotModal,
      observableAttributes: [
        "docid",
        "ptid",
        "clinicid",
        "show",
        "returnfullapt",
      ],
    },
    "apt-activity": {
      Component: ExposableAptActivity,
      observableAttributes: ["aid"],
    },
  },
  ApplicationWrapper: ApplicationWrapper,
});

populateBusinessUsersFuse();
